import './contentComponent.scss';

import { PrismicLocation } from "../../graphql-types";
import StickyHeader from "./sticky-header";
import { Content } from "./content";
import React = require("react");
import Swiper, { ReactIdSwiperProps, SwiperInstance } from 'react-id-swiper';
import GlobalContext from '../context/globalContext';

interface IProps {
  isComponent?: boolean
  prismicLocation: PrismicLocation
  className?: string
}

export const ContentComponent: React.FC<IProps> = props => {
  const { isComponent, prismicLocation } = props
  const { isMobileSize } = React.useContext(GlobalContext)

  return (
    <>
      <div className={isMobileSize ? "card mobile-size" : "card"} data-page={!!isComponent}>
        {isComponent && <StickyHeader />}
        {!isComponent && isMobileSize &&  <input type="checkbox" name="card-opener" className="card-opener" />}
        <img className="content-image" src={prismicLocation.data.header_image.url} />

        {prismicLocation.uid === 'herschel-museum' ? <img src={require("../assets/images/pin1.png")} className="number-pin" /> : ""}
        {prismicLocation.uid === 'south-quay' ? <img src={require("../assets/images/pin2.png")} className="number-pin" /> : ""}
        {prismicLocation.uid === 'st-andrews' ? <img src={require("../assets/images/pin3.png")} className="number-pin" /> : ""}
        {prismicLocation.uid === 'fashion-museum' ? <img src={require("../assets/images/pin4.png")} className="number-pin" /> : ""}
        {prismicLocation.uid === 'fairfield-house' ? <img src={require("../assets/images/pin5.png")} className="number-pin" /> : ""}
        {prismicLocation.uid === 'roman-baths' ? <img src={require("../assets/images/pin6.png")} className="number-pin" /> : ""}
        {prismicLocation.uid === 'king-edwards' ? <img src={require("../assets/images/pin7.png")} className="number-pin" /> : ""}
        {prismicLocation.uid === 'oasis-hub' ? <img src={require("../assets/images/pin8.png")} className="number-pin" /> : ""}
        {prismicLocation.uid === 'mulberry-park' ? <img src={require("../assets/images/pin9.png")} className="number-pin" /> : ""}
        {prismicLocation.uid === 'victoria-park' ? <img src={require("../assets/images/pin10.png")} className="number-pin" /> : ""}
        {prismicLocation.uid === 'innovation-centre' ? <img src={require("../assets/images/pin11.png")} className="number-pin" /> : ""}
         
        <div className="content">
          <div className="content-title">
            {prismicLocation.data.title.text.split(' ')[0]}
            <span> {prismicLocation.data.title.text.split(' ')[1]} {prismicLocation.data.title.text.split(' ')[2]} {prismicLocation.data.title.text.split(' ')[3]} {prismicLocation.data.title.text.split(' ')[4]}</span>
          </div>
          <Content content={{
            past: prismicLocation.data.past.html,
            present: prismicLocation.data.present.html,
            future: prismicLocation.data.future.html
          }} />

        </div>
      </div>
    </>
  )
}